import { render } from "./ModalArquetipoDetalle.vue?vue&type=template&id=a529b064&scoped=true"
import script from "./ModalArquetipoDetalle.vue?vue&type=script&lang=js"
export * from "./ModalArquetipoDetalle.vue?vue&type=script&lang=js"

import "./ModalArquetipoDetalle.vue?vue&type=style&index=0&id=a529b064&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a529b064"]])

export default __exports__